import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Loads dynamic site config (browser tab title + meta description) from backend.
 * Falls back silently to the static values in index.html if the request fails.
 */
const SiteConfigLoader = () => {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/site-config`);
        if (cancelled) return;
        if (data?.siteTitle) {
          document.title = data.siteTitle;
        }
        if (data?.siteDescription) {
          const meta = document.querySelector('meta[name="description"]');
          if (meta) meta.setAttribute('content', data.siteDescription);
        }
      } catch (e) {
        // silent — keep static fallback from index.html
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return null;
};

export default SiteConfigLoader;
